import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginMailComponent } from '../auth-shared/login-mail/login-mail.component';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { auth } from 'firebase/app';
import { MatDialog } from '@angular/material/dialog';
import { Users } from 'my-lib-sanfelici/my-lib-sanfelici';
import { UsersService } from 'my-lib-sanfelici';
import { AuthService } from 'my-lib-sanfelici';


@Component({
  selector: 'app-authenticate',
  templateUrl: './authenticate.component.html',
  styleUrls: ['./authenticate.component.css']
})
export class AuthenticateComponent implements OnInit {
  usr: firebase.User;
  user: Observable<Users>;
  constructor(
    private router: Router,
    public afAuth: AngularFireAuth,
    public usersservice: UsersService,
    public authservice: AuthService,
    public dialog: MatDialog
  ) { }

  async loginGoogle() {
const provider= new auth.GoogleAuthProvider();

await this.afAuth.auth.signInWithPopup(provider).then(u => {

  this.router.navigate(['/myuser','contatti','details', u.user.uid]);

});
 }
 async LoginFaceBook() {
  const provider = new auth.FacebookAuthProvider();
  provider.addScope('email');
  const credential = await this.afAuth.auth.signInWithPopup(provider)
  .then(u=>{
    this.router.navigate(['/myuser','contatti','details',u.user.uid]);
  });
 }
 openDialogMail(): void {
   const dialogRef = this.dialog.open(LoginMailComponent, {
     width: '250px'
   });

   dialogRef.afterClosed().subscribe(() => {

   });
 }

  ngOnInit() {
    this.authservice.usr.subscribe(u=>this.usr=u);

  }

}
